module.exports = __webpack_public_path__ + "static/media/WebCasino.6f9cb67e.webm";